import script from "./BusinessData.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessData.vue?vue&type=script&setup=true&lang=js"

import "./BusinessData.vue?vue&type=style&index=0&id=1db9f6aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db9f6aa"]])

export default __exports__